import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReferralRequestStatus, RespondentType } from './generated/referral-request';
import { useCreateReferralRequest } from './hooks/use-create-referral-request';
import { ReferralRequestFormPage } from './referral-request-form-page';
import { type ReferralRequestFormValues } from './referral-request-form-utils';

type ReferralRequestCreateProps = {
  readonly orgCode: string;
  readonly serviceCode: string;
  readonly service: { description: string; respondentTypes: RespondentType[] };
};

const ReferralRequestCreate = ({ orgCode, serviceCode, service }: ReferralRequestCreateProps) => {
  const navigate = useNavigate();
  const { result, createReferralRequest } = useCreateReferralRequest();

  const saveReferralRequest = async (values: ReferralRequestFormValues) => {
    await createReferralRequest({ orgCode, serviceCode, status: ReferralRequestStatus.Draft, ...values });
  };

  useEffect(() => {
    if (!result) return;
    navigate(result.surveyResponseId ? `/referral-request/${result.id}/survey` : '/');
  }, [result, navigate]);

  return <ReferralRequestFormPage onSave={saveReferralRequest} service={service} />;
};

export { ReferralRequestCreate };
